/* AMR — ticker, size quick-add and set panel. No dependencies. */
(function () {
  'use strict';

  /* ---------- Announcement ticker ---------- */

  function setupTicker(ticker) {
    if (ticker.dataset.ready) return;
    ticker.dataset.ready = 'true';

    var group = ticker.querySelector('.amr-ticker__group');
    var track = ticker.querySelector('.amr-ticker__track');
    var speed = parseFloat(ticker.dataset.speed) || 40; // pixels per second

    function measure() {
      if (!group || !track) return;
      var width = group.getBoundingClientRect().width;
      if (width > 0) track.style.setProperty('--amr-ticker-duration', (width / speed).toFixed(2) + 's');
      document.documentElement.style.setProperty('--amr-ticker-h', ticker.offsetHeight + 'px');
    }

    measure();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    window.addEventListener('resize', measure, { passive: true });

    var toggle = ticker.querySelector('.amr-ticker__toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var paused = ticker.hasAttribute('data-paused');
        if (paused) {
          ticker.removeAttribute('data-paused');
          toggle.setAttribute('aria-pressed', 'false');
          toggle.setAttribute('aria-label', toggle.dataset.labelPause);
        } else {
          ticker.setAttribute('data-paused', '');
          toggle.setAttribute('aria-pressed', 'true');
          toggle.setAttribute('aria-label', toggle.dataset.labelPlay);
        }
      });
    }
  }

  function initTickers(root) {
    (root || document).querySelectorAll('.amr-ticker').forEach(setupTicker);
  }

  /* ---------- Size quick-add ---------- */

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function setStatus(card, text, tone) {
    var status = card && card.querySelector('[data-amr-status]');
    if (!status) return;
    status.textContent = text || '';
    if (tone) status.setAttribute('data-tone', tone);
    else status.removeAttribute('data-tone');
  }

  function addLines(lines) {
    var actions = window.Shopify && window.Shopify.actions;

    if (actions && typeof actions.updateCart === 'function') {
      return actions
        .updateCart({
          lines: lines.map(function (line) {
            return { merchandiseId: String(line.id), quantity: line.quantity || 1 };
          }),
        })
        .then(function (result) {
          if (result && result.userErrors && result.userErrors.length) {
            throw new Error(result.userErrors[0].message);
          }
          return { openCart: typeof actions.openCart === 'function' ? actions.openCart : null };
        });
    }

    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: lines.map(function (line) {
          return { id: Number(line.id), quantity: line.quantity || 1 };
        }),
      }),
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || 'Error');
        return { redirect: true };
      });
    });
  }

  function finish(result) {
    if (result && result.redirect) {
      window.location.href = rootUrl() + 'cart';
      return;
    }
    if (result && result.openCart) {
      Promise.resolve(result.openCart()).catch(function () {});
    }
  }

  /* Size chips on product cards */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-amr-add]');
    if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();

    var card = button.closest('.amr-card');
    var addedText = button.getAttribute('data-added-text') || '';
    var errorText = button.getAttribute('data-error-text') || '';

    button.setAttribute('aria-busy', 'true');
    setStatus(card, '');

    addLines([{ id: button.getAttribute('data-amr-add'), quantity: 1 }])
      .then(function (result) {
        button.setAttribute('data-state', 'added');
        setStatus(card, addedText);
        finish(result);
        window.setTimeout(function () {
          button.removeAttribute('data-state');
          setStatus(card, '');
        }, 2600);
      })
      .catch(function (error) {
        setStatus(card, (error && error.message) || errorText, 'error');
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
      });
  });

  /* ---------- Set panel ---------- */

  function sheetStatus(sheet, text, tone) {
    var status = sheet.querySelector('[data-amr-status]');
    if (!status) return;
    if (!status.hasAttribute('data-default')) status.setAttribute('data-default', status.textContent);
    status.textContent = text == null ? status.getAttribute('data-default') : text;
    if (tone) status.setAttribute('data-tone', tone);
    else status.removeAttribute('data-tone');
  }

  function sheetSelection(sheet) {
    var items = sheet.querySelectorAll('[data-amr-set-item]');
    var lines = [];
    var complete = true;
    items.forEach(function (item) {
      var checked = item.querySelector('input[type="radio"]:checked');
      if (checked) lines.push({ id: checked.value, quantity: 1 });
      else complete = false;
    });
    return { lines: lines, complete: complete && lines.length > 0 };
  }

  function refreshSheet(sheet) {
    var button = sheet.querySelector('[data-amr-set-add]');
    if (!button) return;
    var selection = sheetSelection(sheet);
    button.disabled = !selection.complete;
    button.textContent = selection.complete
      ? button.getAttribute('data-label-ready')
      : button.getAttribute('data-label-pending');
  }

  function openSheet(sheet, opener) {
    if (!sheet || typeof sheet.showModal !== 'function') return false;
    sheet._opener = opener || null;
    sheet.showModal();
    document.documentElement.setAttribute('scroll-lock', '');
    refreshSheet(sheet);
    return true;
  }

  function closeSheet(sheet) {
    if (sheet && sheet.open) sheet.close();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-amr-sheet-open]');
    if (opener) {
      var sheet = document.getElementById(opener.getAttribute('data-amr-sheet-open'));
      if (openSheet(sheet, opener)) event.preventDefault();
      return;
    }

    var closer = event.target.closest('[data-amr-sheet-close]');
    if (closer) {
      closeSheet(closer.closest('[data-amr-sheet]'));
      return;
    }

    // Tap on the dimmed area closes the panel
    if (event.target.matches && event.target.matches('dialog[data-amr-sheet]')) {
      var rect = event.target.getBoundingClientRect();
      var inside =
        event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) closeSheet(event.target);
      return;
    }

    var add = event.target.closest('[data-amr-set-add]');
    if (!add || add.disabled || add.getAttribute('aria-busy') === 'true') return;

    var panel = add.closest('[data-amr-sheet]');
    var selection = sheetSelection(panel);
    if (!selection.complete) return;

    add.setAttribute('aria-busy', 'true');
    add.disabled = true;
    sheetStatus(panel, '');

    addLines(selection.lines)
      .then(function (result) {
        // Open the cart only after the panel has fully closed
        panel.addEventListener(
          'close',
          function () {
            finish(result);
          },
          { once: true }
        );
        closeSheet(panel);
      })
      .catch(function (error) {
        sheetStatus(panel, (error && error.message) || add.getAttribute('data-error-text'), 'error');
      })
      .finally(function () {
        add.removeAttribute('aria-busy');
        refreshSheet(panel);
      });
  });

  document.addEventListener('change', function (event) {
    var sheet = event.target.closest && event.target.closest('[data-amr-sheet]');
    if (sheet) {
      sheetStatus(sheet, null);
      refreshSheet(sheet);
    }
  });

  document.addEventListener(
    'close',
    function (event) {
      if (!event.target.matches || !event.target.matches('[data-amr-sheet]')) return;
      document.documentElement.removeAttribute('scroll-lock');
      var opener = event.target._opener;
      if (opener && typeof opener.focus === 'function' && !document.querySelector('dialog[open]')) opener.focus();
    },
    true
  );

  /* ---------- Cart page mode: go to the cart after adding ---------- */
  // With a full cart page (no drawer), customers land on the cart after every
  // successful add, so "back" from checkout and removing items stay on the cart.
  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (event.action !== 'add') return;
    if (document.querySelector('theme-drawer#cart-drawer')) return;
    if (/\/cart\/?$/.test(window.location.pathname)) return;
    if (!event.promise || typeof event.promise.then !== 'function') return;

    event.promise
      .then(function (result) {
        var failed =
          (result && result.detail && result.detail.didError) || (result && result.userErrors && result.userErrors.length);
        if (failed) return;
        window.setTimeout(function () {
          window.location.href = rootUrl() + 'cart';
        }, 350);
      })
      .catch(function () {});
  });

  /* ---------- Boot ---------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTickers();
    });
  } else {
    initTickers();
  }

  // Theme editor: re-init when a section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    initTickers(event.target);
  });
})();
